// The vessel open in the app, sent with every /api/ call as the header X-HC-Vessel (src/lib/authFetch.js) so the server answers
// about THAT vessel (fleet-review: a management login's chat used the company's first vessel). null = no vessel open (a
// management login on its fleet view): no header - the server then never picks a vessel itself. Set by src/hooks/useAuth.js.
let _open = null
export function setOpenVessel(cfg) { _open = cfg && cfg.id && cfg.accountType !== 'company' ? String(cfg.id) : null }
export const openVesselId = () => _open
